import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const MailOption = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='MailOption' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,4 L23,4 L23,20 L1,20 L1,4 Z M1,5 L12,13.5 L23,5' />
  </StyledIcon>
);
